<template>
  <div class="offers">
    <app-layout customToolbar centered>
      <template v-slot:body>
        <div class="container col-lg-8 col-sm-12">
          <BaseListToolbar @search="updateSearchValue" title="Offers">
            <template v-slot:inline-filters>
              <OfferListFilter
                @onClearFilters="clearFilters"
                :isLoading="isFetchingOffers"
                :availableFilters="availableFilters"
                @filter="updateFilters"
              />
            </template>
          </BaseListToolbar>
          <div v-if="isFetchingOffers">
            <v-skeleton-loader
              v-for="i in 5"
              :key="i"
              type="list-item-avatar"
            />
          </div>
          <div v-else>
            <div v-if="isNotEmpty">
              <OfferList :offers="formattedOffers" />
              <v-pagination
                :total-visible="page.pageSize"
                v-if="showPagination"
                v-model="page.currentPage"
                @input="loadOffers"
                :length="page.lastPage"
              />
            </div>
            <EmptyStates
              v-else
              icon="offers-empty-state"
              :description="emptyStateDescription"
              :isFiltered="isFiltered"
            />
          </div>
        </div>
      </template>
    </app-layout>
  </div>
</template>

<script>
import appLayout from "@/components/common/base-layouts/AppLayout";
import BaseListToolbar from "@/components/common/Toolbar/BaseListToolbar";
import OfferList from "@/views/offers/components/OfferList";
import { FETCH_OFFERS } from "@/store/modules/offers/actions";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import { createNamespacedHelpers } from "vuex";
import { map, size } from "lodash";
import { getFullName } from "@/utils/users";
import EmptyStates from "@/components/common/EmptyStates";
import { paginationMixin } from "@/mixins/pagination.mixin";
import OfferListFilter from "@/views/offers/components/OfferListFilter";

const { mapActions, mapState } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  title: "Offers - Track",
  name: "Offers",
  mixins: [paginationMixin],
  components: {
    appLayout,
    OfferList,
    BaseListToolbar,
    EmptyStates,
    OfferListFilter
  },
  data() {
    return {
      availableFilters: { booking_id: null },
      search: ""
    };
  },
  created() {
    this.loadOffers();
  },
  computed: {
    ...mapState(["offers", "isFetchingOffers"]),
    formattedOffers() {
      return map(this.offers, offer => {
        if (offer.application) {
          const { user, booking } = offer.application;
          const candidate = getFullName(user);
          const { title } = booking || { title };
          return { ...offer, candidate, title };
        }
        return offer;
      });
    },
    requestParams() {
      return {
        filter: {
          ...(this.availableFilters.booking_id && { ...this.availableFilters }),
          ...(size(this.search) && { search: this.search })
        },
        ...this.requestPageParams
      };
    },
    isNotEmpty() {
      return size(this.formattedOffers);
    },
    isFiltered() {
      return Boolean(size(this.search));
    },
    emptyStateDescription() {
      return this.isFiltered
        ? "No offers match your search criteria"
        : "No offers have been made";
    }
  },
  methods: {
    ...mapActions({
      fetchOffers: FETCH_OFFERS
    }),
    async loadOffers() {
      const data = await this.fetchOffers(this.requestParams);
      if (data) {
        this.adjustPageDetails(data.meta);
      }
    },
    adjustPageDetails(meta) {
      this.updatePageDetails(meta);
      this.availableFilters = { booking_id: null };
    },
    updateSearchValue(text) {
      this.search = text;
      this.loadOffers();
    },
    clearFilters() {
      this.availableFilters = { booking_id: null };
      this.loadOffers();
    },
    updateFilters(filters) {
      this.availableFilters = filters;
      this.loadOffers();
    }
  }
};
</script>

<style lang="scss">
.offers {
  position: relative;
  tr {
    cursor: pointer;
  }
  .offer-action-icon {
    width: 33px;
    height: 26px;
    margin: auto auto 2px auto;
  }
}
</style>
